import { Star, MapPin, ShieldCheck, Clock } from "lucide-react";

const ITEMS = [
  { icon: Star,        title: "4.9",             label: "Google Reviews",     testid: "trust-reviews",  bold: true },
  { icon: MapPin,      title: "Sersi",            label: "Near Heritage Helipad", testid: "trust-location" },
  { icon: ShieldCheck, title: "Secure",           label: "Verified Booking",   testid: "trust-secure" },
  { icon: Clock,       title: "24 × 7",           label: "Concierge Support",  testid: "trust-concierge" },
];

export const TrustBand = ({ dark = false }) => {
  const bg = dark ? "bg-[#0F0F0F] text-[#F8F6F2] border-y border-[#D4AF37]/20" : "bg-surface text-ink border-y border-kc";
  const iconClr = dark ? "text-[#D4AF37]" : "text-gold";
  const titleClr = dark ? "text-[#F8F6F2]" : "text-ink";
  const labelClr = dark ? "text-[#F8F6F2]/60" : "text-ink-mute";

  return (
    <section className={`${bg}`} data-testid="trust-band">
      <div className="max-w-[1500px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-2 md:grid-cols-4 divide-x divide-y md:divide-y-0 divide-[color:var(--kc-line)]">
          {ITEMS.map((it, i) => (
            <div key={it.testid} className="flex items-center gap-5 px-6 md:px-8 py-8 md:py-10" data-testid={it.testid}>
              <it.icon size={22} className={`${iconClr} shrink-0`} strokeWidth={1.2} />
              <div className="flex flex-col leading-tight">
                <span className={`font-serif-display text-2xl md:text-3xl ${titleClr} tracking-[-0.01em]`}>
                  {it.title}
                  {it.bold && <span className={`${iconClr} ml-1`}>★</span>}
                </span>
                <span className={`text-[10px] md:text-[11px] uppercase tracking-[0.28em] mt-1.5 ${labelClr}`}>
                  {it.label}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
